import { call, put, select } from 'typed-redux-saga'

import services from '@services'
import { ApplicationState } from '@store/types'
import { setBancosLoading } from '@store/refinanciamento/dadosBancarios/actions'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { StepRefin } from '@utils/enums'

import {
  getDadosPessoaisError,
  getDadosPessoaisSuccess,
  setHasEndereco,
  setHasDadosBancarios,
  getDadosPessoaisRequest,
} from '../actions'
import { GetDadosPessoaisSagaPayload } from '../types'
import {
  applyAddressDataFromResponse,
  applyBankDataFromResponse,
  applyCustomerDataFlagsFromResponse,
  hasCompleteDadosBancarios,
  hasCompleteEndereco,
} from './getDadosPessoaisHydration'

export default function* getDadosPessoaisSaga(action: GetDadosPessoaisSagaPayload) {
  const { callback } = action.payload

  try {
    const { accessToken } = yield* select((state: ApplicationState) => state.session)
    yield* put(setBancosLoading(true))

    const { data: resp } = yield* call(services.getDadosPessoaisService, accessToken)
    yield* put(setLastServiceResponse({ code: 'OK', serviceName: 'getDadosPessoaisService' }))

    const correctionMode = yield* select(
      (state: ApplicationState) => state.refinanciamento.dadosPessoais?.correctionMode,
    )

    yield* applyAddressDataFromResponse(resp?.addressData)
    if (!correctionMode) {
      yield* applyBankDataFromResponse(resp?.bankData)
    }
    yield* applyCustomerDataFlagsFromResponse(resp)

    const endereco = yield* select((state: ApplicationState) => state.refinanciamento.endereco)
    const dadosBancarios = yield* select(
      (state: ApplicationState) => state.refinanciamento.dadosBancarios,
    )

    yield* put(setBancosLoading(false))
    yield* put(getDadosPessoaisSuccess())
    yield* put(setHasEndereco(hasCompleteEndereco(endereco)))
    yield* put(setHasDadosBancarios(hasCompleteDadosBancarios(dadosBancarios)))
    yield* call(callback)
  } catch {
    yield* put(setLastServiceResponse({ code: 'ERROR', serviceName: 'getDadosPessoaisService' }))
    yield* put(setBancosLoading(false))
    yield* put(getDadosPessoaisError())
    yield* put(
      showError({
        title: 'Erro ao buscar dados',
        message: 'Ocorreu um erro ao buscar as informações',
        actionTitle: 'Tentar Novamente',
        code: StepRefin.ERRO_BUSCAR_DADOS_PESSOAIS,
        actionCallback: () => getDadosPessoaisRequest({ callback }),
      }),
    )
  }
}
